import { fetchData, postData, putData } from 'modules/Axios';
import { notifyFailure, notifySuccess } from 'modules/Notifications';

export const defaultState = {
  integration: null,
  destinations: {},
};

export const initEditIntegration = (id) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const URL = `brands/${brand.id}/integrations/${id}`;
    const integration = await dispatch(fetchData(URL))
      .catch((e) => {
        notifyFailure(e.message);
        return defaultState.integration;
      });
    dispatch(updateIntegration(integration));
    await dispatch(getDestinations());
    return integration;
  };
};

export const UPDATE_INTEGRATION = 'UPDATE_INTEGRATION';
export const updateIntegration = (integration) => ({
  type: UPDATE_INTEGRATION,
  payload: integration,
});

export const saveIntegration = (integrationDTO, id) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const integration = await dispatch(putData(`brands/${brand.id}/integrations/${id}`, { ...integrationDTO }))
      .catch((e) => {
        console.error('API Call to create integration failed...', e);
        notifyFailure('Failed to create integration');
        return defaultState.integration;
      });

    if (integration) {
      notifySuccess('Integration Updated Successfully');
      dispatch(updateIntegration(integration));
      return integration;
    }
  };
};

export const GET_DESTINATIONS = 'GET_DESTINATIONS';

export const getDestinations = () => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    const URL = `/brands/${brand.id}/audiences/destinations`;
    try {
      const destinations = await dispatch(fetchData(URL));
      dispatch({type: GET_DESTINATIONS, payload: destinations});
    } catch (e) {
      console.error('API Call to /integrationTypes failed...', e);
      notifyFailure('Failed to retrieve integration types');
    }
  };
};

export const saveSshFile = (fileData, updateFileUploadingProgress) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    try {
      const getSshKeyId = await dispatch(postData(`brands/${brand.id}/integrations/ssh_keys`, fileData, null, true, 'json', updateFileUploadingProgress));
      return getSshKeyId;
    } catch (e) {
      console.error('API Call to upload audience file failed...', e);
      notifyFailure('Failed to upload audience file');
      return null;
    }
  };
};

export const saveEncryptionFile = (fileData, updateFileUploadingProgress) => {
  return async (dispatch, getState) => {
    const { brand } = getState().app;
    try {
      const getEncryptionKeyId = await dispatch(postData(`brands/${brand.id}/integrations/encryption_keys`, fileData, null, true, 'json', updateFileUploadingProgress));
      return getEncryptionKeyId;
    } catch (e) {
      console.error('API Call to upload audience file failed...', e);
      notifyFailure('Failed to upload audience file');
      return null;
    }
  };
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case UPDATE_INTEGRATION:
      return {
        ...state,
        integration: action.payload,
      };
    case GET_DESTINATIONS:
      return {
        ...state,
        destinations: action.payload,
      };
    default:
      return state;
  }
}
